export default "__VITE_ASSET__CBrUFr9L__"